import { Card } from './card';

export class PaymentItem {
  constructor(data) {
    this.isActive = data.isActive;
    this.amount = data.amount;
    this.approveDate = data.approveDate;
    this.checkNumber = data.checkNumber;
    this.createDate = data.createDate;

    /** @type {Card} */
    this.creditCard = data.creditCard;

    this.editDate = data.editDate;
    this.id = data.id;
    this.isCheckType = data.isCheckType;
    this.name = data.name;
    this.refId = data.refId;
    this.transactionId = data.transactionId;
    this.type = data.type ? {
      code: data.type.code,
      id: data.type.id,
      name: data.type.name,
    } : null;
    this.typeId = data.typeId;
    this.userId = data.userId;
  }
}
